import {
  FETCH_SMTP,
  FETCH_SMTP_SUCCESS,
  FETCH_SMTP_FAILED
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { get } from "firebase/database";
import { postWithIdToken } from './mileactions';

export const fetchSMTP = () => async (dispatch) => {

  const {
    smtpRef
  } = firebase;

  dispatch({
    type: FETCH_SMTP,
    payload: null,
  });
  try {
    const snapshot = await get(smtpRef);
    if (snapshot.val()) {
      dispatch({
        type: FETCH_SMTP_SUCCESS,
        payload: snapshot.val(),
      });
    } else {
      dispatch({
        type: FETCH_SMTP_FAILED,
        payload: "Unable to fetch SMTP details.",
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_SMTP_FAILED,
      payload: error.message,
    });
  }
};

// checksmtpdetails sends a test mail and then replaces /smtpdata (the mail
// server every outgoing email uses), so the server only accepts a signed-in
// admin: the admin's Firebase ID token goes as `Authorization: Bearer`
// (postWithIdToken; same host rule as the other Bearer calls). The answer
// keeps its old shape - { success: true } or { error } - and a refusal
// (401/403, network) comes back as { success: false, code, error } instead
// of throwing, so the settings page still shows its alert.
export const checkSMTP = async(fromEmail, smtpDetails) => {
  try {
    return await postWithIdToken('/checksmtpdetails', { fromEmail: fromEmail, smtpDetails: smtpDetails });
  } catch (error) {
    return {
      success: false,
      code: (error && error.code) || null,
      error: (error && error.payload && error.payload.error) || (error && error.message) || 'Request failed'
    };
  }
}